import axios, { AxiosRequestConfig } from "axios";
import { Signal } from "signals";
import { Connector } from "slotworks/server/connectors/connector";
import Contract from "slotworks/utils/contract";

class HTTPConnector implements Connector {

    public withCredentials: boolean = false;
    public contentType: string = "application/json";

    private errorSignal: Signal = new Signal();

    public sendRequest(request: any): Contract<{}> {
        const axiosRequest = request as AxiosRequestConfig;
        axiosRequest.withCredentials = this.withCredentials;

        if (!axiosRequest.headers) {
            axiosRequest['headers'] = {
                "Content-Type": this.contentType
            };
        }
        else {
            axiosRequest.headers['Content-Type'] = this.contentType;
        }


        return new Contract((resolve) => {
            axios.request(axiosRequest)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if (error.message === "Network Error" || error.message.indexOf("Request failed") > -1) {
                        this.errorSignal.dispatch("err.con");
                    } else {
                        throw error;
                    }
                });
        });
    }

    public onError(method: (message: string) => void) {
        this.errorSignal.add(method);
    }
}

export default new HTTPConnector();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/server/connectors/http-connector.ts